module.exports = __webpack_public_path__ + "static/media/metrc_bw.eb2f8fdd.png";